// Kickard presentation-only cosmetic slots.
// IMPORTANT: This module must NEVER be imported by engine/rules/server/ranked/RNG code.

export const gameplayPresentation = Object.freeze({
  stadiumThemeId: 'default',
  ballSkinId: 'default',
  cardBackId: 'default',
  penaltyShootSceneId: 'default',
  penaltyDefendSceneId: 'default',

  assets: Object.freeze({
    stadiumShell: '/gameplay/stadium_shell_default.png',
    pitchGrass: '/gameplay/pitch_grass_default.webp',
    pitchMarkings: '/gameplay/pitch_markings.svg',
    goalFrame: '/gameplay/goal_frame_default.svg',
    ballSkin: '/gameplay/ball_skin_default.png',
    cardBack: '/gameplay/card_back_default.png',
    hudTopShell: '/gameplay/hud_top_shell.svg',
    hudBottomShell: '/gameplay/hud_bottom_shell.svg',
    // Phase 5.0B — premium sideline ad panels. Presentation-only.
    // Orientation inside each file is already correct: LEFT for the
    // left rail, RIGHT for the right rail. Never mirror / rotate.
    // LEFT  = "RANK HIGHER · PLAY SMART · WIN BIG"
    // RIGHT = "BEAT THE BEST PLAYERS · SKILL · STRATEGY · VICTORY"
    leftSidelineAdAsset:  '/gameplay/sideline_ad_left.webp',
    rightSidelineAdAsset: '/gameplay/sideline_ad_right.webp',
    // Phase 5.0B-4 — Penalty Shootout premium assets. Presentation-only.
    penaltySceneShoot:      '/penalty/penalty_scene_shoot.webp',
    penaltySceneDefend:     '/penalty/penalty_scene_defend.webp',
    penaltyHudShell:        '/penalty/penalty_hud_shell.svg',
    penaltyCardTrayShell:   '/penalty/penalty_card_tray_shell.svg',
    penaltySelectedCardFrame: '/penalty/penalty_selected_card_frame.svg',
    penaltyDividerGlow:     '/penalty/penalty_divider_glow.svg',
    penaltyDotEmpty:        '/penalty/penalty_dot_empty.svg',
    penaltyDotGoal:         '/penalty/penalty_dot_goal.svg',
    penaltyDotMiss:         '/penalty/penalty_dot_miss.svg',
  }),

  // Current sponsor placeholders. Render these as real DOM text/content.
  // Do NOT bake sponsor copy into stadium art.
  sponsorSlots: Object.freeze({
    left: { id: 'sideSponsorLeft', fallbackText: 'KICKARD' },
    right: { id: 'sideSponsorRight', fallbackText: 'KICKARD' }
  })
});

// Reserved for later Phase 5.0D / cosmetics. NOT implemented now:
// goalVfxId, shotTrailId, celebrationVfxId
